import { render } from "./EditarAnalise.vue?vue&type=template&id=4bc1750a"
import script from "./EditarAnalise.vue?vue&type=script&lang=js"
export * from "./EditarAnalise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__